import { Undo2, Upload } from 'lucide-react';

import type { VenueBookingPhoto } from '../../../../../api/venues';

import { useFocusRequest } from './use-focus-request';

import '../venue-booking-content.css';

export interface PhotoActionsProps {
  source: VenueBookingPhoto['source'];
  disabled: boolean;
  phone: boolean;
  buttonHeight: number;
  /** True when focus should move to the main button, which then says it has. */
  focusRequested: boolean;
  onFocused: () => void;
  onChoose: () => void;
  onRemove: () => void;
}

/** The buttons under the preview: pick a file, and remove an uploaded photo. */
export function PhotoActions({
  source,
  disabled,
  phone,
  buttonHeight,
  focusRequested,
  onFocused,
  onChoose,
  onRemove,
}: PhotoActionsProps) {
  const chooseButton = useFocusRequest<HTMLButtonElement>(focusRequested, onFocused);
  const style = {
    height: buttonHeight,
    fontSize: 12.5,
    ...(phone ? { width: '100%', justifyContent: 'center' } : {}),
  } as const;
  const chooseLabel =
    source === 'staff'
      ? 'Replace photo'
      : source === 'imported'
        ? 'Upload a new photo'
        : 'Upload photo';
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: phone ? 'column' : 'row',
        gap: 8,
        flexWrap: 'wrap',
        alignItems: phone ? 'stretch' : 'center',
      }}
    >
      <button
        ref={chooseButton}
        type="button"
        className={source === null ? 'nb-btn nb-btn-primary' : 'nb-btn'}
        disabled={disabled}
        onClick={onChoose}
        style={style}
      >
        <Upload size={13} aria-hidden="true" />
        {chooseLabel}
      </button>
      {source === 'staff' && (
        <button
          type="button"
          className="nb-btn nb-btn-ghost"
          disabled={disabled}
          onClick={onRemove}
          style={style}
        >
          <Undo2 size={12} aria-hidden="true" />
          Remove uploaded photo
        </button>
      )}
    </div>
  );
}
